var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"googlesign"}},[_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){return _vm.onGoogleSignInUpBtnClicked()}}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'google']}}),_vm._v(" Google Sign in / up\n    ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c74eb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoogleSign.vue
// module id = null
// module chunks = 